import { createSelector } from 'reselect';

import { createParameterSelector } from '@pressreader/appstore';
import { selectGetConfigValue } from '@pressreader/config';

import { CommentsDialogStatus } from '../../types/comments.dialog';
import { getState } from '../reducers';

const selectCommonState = createSelector(getState, state => state.common);

export const selectCommentDraftId = createParameterSelector<'draftId', string>('draftId');

export const selectIsLoaded = createSelector(selectCommonState, state => state.isLoaded);

export const selectPopupId = createSelector(selectCommonState, state => state.popupId);

export const selectArticleId = createSelector(selectCommonState, state => state.articleId);

export const selectPopupStatus = createSelector(selectCommonState, state => state.popupStatus);

export const selectOrderBy = createSelector(selectCommonState, state => state.orderBy);

export const selectIsDialogOpenedOrOpening = createSelector(
    selectPopupStatus,
    popupStatus => popupStatus === CommentsDialogStatus.OPEN || popupStatus === CommentsDialogStatus.OPENING,
);

/**
 * Selects whether a click on the user profile should be disabled in the comments dialog.
 */
export const selectIsOpenUserProfileClickDisabled = createSelector(selectGetConfigValue, getConfigValue =>
    getConfigValue<boolean>('features.comments.dialog.profile.click.disabled', false),
);
